window.PatientModel = {
    getDefaultFinancialInstitution: function (params, callback) {
        $.getJSON('/patients/get_default_financial_institution', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (callback) {
                    callback(data.success, data);
                }
            })
            .fail(function (xhr, status, error) {
                if (callback) {
                    callback(error, null);
                }
            });
    },
    getPatientInfo: function (params, callback) {
        debug.log('PatientModel.onPatientInfoLoaded - params',params);
        $.getJSON('/patients/get_patient_info', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (callback) {
                    callback(data.success, data);
                }
            })
            .fail(function (xhr, status, error) {
                if (callback) {
                    callback(error, null);
                }
            });
    }
};